"use client";

import { Edit, Trash2 } from "lucide-react";
import type { ListItem } from "../types";

interface ListItemRowProps {
  item: ListItem;
  index: number;
  isEditing: boolean;
  primaryField: string;
  secondaryField?: string;
  onEdit: (item: ListItem) => void;
  onDelete: (item: ListItem) => void;
}

export const ListItemRow = ({
  item,
  index,
  isEditing,
  primaryField,
  secondaryField,
  onEdit,
  onDelete,
}: ListItemRowProps) => {
  const itemId = item.id;
  const primaryValue = item[primaryField] || "";
  const secondaryValue = secondaryField ? item[secondaryField] : "";

  return (
    <div
      key={itemId || `item-${index}`}
      className={`flex items-center gap-2 px-2 py-1.5 rounded group transition-colors ${
        isEditing ? "bg-blue-50 border border-blue-300" : "hover:bg-gray-100"
      }`}
    >
      <div className="flex-1 flex items-center gap-2 min-w-0">
        <span className="font-medium text-gray-900 truncate">{primaryValue}</span>
        {secondaryField && secondaryValue && (
          <span className="text-xs text-gray-400 truncate">/{secondaryValue}</span>
        )}
      </div>

      <div className="flex gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0">
        <button
          onClick={() => onEdit(item)}
          className="p-1 hover:bg-blue-100 rounded text-blue-600"
          title="Edit"
        >
          <Edit className="w-3.5 h-3.5" />
        </button>
        <button
          onClick={() => onDelete(item)}
          className="p-1 hover:bg-red-100 rounded text-red-600"
          title="Delete"
        >
          <Trash2 className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};

